import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { InMemoryStorageService } from './services/in-memory-storage.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { SessionService } from './services/session.service';
import { AppComponent } from '../app.component';
import { AppStateService } from './services/app-state.service';
import { RefreshTokenService } from './services/refresh-token.service';
import { OrderDraftService } from './services/order-draft.service';

// Assuming you have an AuthService for handling authentication logic

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    private isLoggingOut = false;

    constructor(
        private router: Router,
        private inMemoryStorageService: InMemoryStorageService,
        private http: HttpClient,
        private sessionService: SessionService,
        private appState: AppStateService,
        private refreshTokenService: RefreshTokenService,
        private orderDraftService: OrderDraftService
    ) {}
    // private getUserStatus(username: string): number | null {
    //     try {
    //         const xhr = new XMLHttpRequest();
    //         xhr.open('GET', `${environment.authApiUrl}verify-status?username=${encodeURIComponent(username)}`, false); // synchronous
    //         xhr.send(null);
    //         if (xhr.status === 200) {
    //             try {
    //                 const response = JSON.parse(xhr.responseText);
    //                 console.log(response, 'User status response');

    //                 if (typeof response === 'number') {
    //                     return response;
    //                 }
    //             } catch (e) {
    //                 const num = parseInt(xhr.responseText, 10);
    //                 if (!isNaN(num)) {
    //                     return num;
    //                 }
    //             }
    //         }
    //     } catch (e) {
    //         console.error('Error verifying user status:', e);
    //     }
    //     return null;
    // }
    //   private getUserStatus(username: string): number | null {
    //     try {
    //         const token = localStorage.getItem('accessToken');
    //         const xhr = new XMLHttpRequest();
    //         xhr.open('GET', `${environment.authApiUrl}verify-status?username=${encodeURIComponent(username)}`, false); // synchronous

    //         // Set the Authorization header if token exists
    //         if (token) {
    //             xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    //         }

    //         xhr.send(null);
    //         if (xhr.status === 200) {
    //             try {
    //                 const response = JSON.parse(xhr.responseText);

    //                 if (typeof response === 'number') {
    //                     return response;
    //                 }
    //             } catch (e) {
    //                 const num = parseInt(xhr.responseText, 10);
    //                 if (!isNaN(num)) {
    //                     return num;
    //                 }
    //             }
    //         }
    //     } catch (e) {
    //         console.error('Error verifying user status:', e);
    //     }
    //     return null;
    // }
    private getUserStatus(username: string): number | null {
        try {
            let token = localStorage.getItem('accessToken');
            if (token?.startsWith('"') && token?.endsWith('"')) {
                token = token.slice(1, -1);
            }
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `${environment.authApiUrl}verify-status?username=${encodeURIComponent(username)}`, false);
            // Set the Authorization header if token exists
            if (token) {
                xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            }

            xhr.send(null);
            if (xhr.status === 200) {
                try {
                    const response = JSON.parse(xhr.responseText);

                    if (typeof response === 'number') {
                        return response;
                    }
                } catch (e) {
                    const num = parseInt(xhr.responseText, 10);
                    if (!isNaN(num)) {
                        return num;
                    }
                }
            }
        } catch (e) {
            console.error('Error verifying user status:', e);
        }
        return null;
    }

    // private getUserStatus(username: string): number | null {
    //     try {
    //         const token = localStorage.getItem('accessToken');
    //         const xhr = new XMLHttpRequest();
    //         xhr.open('GET', `${environment.authApiUrl}verify-status?username=${encodeURIComponent(username)}`, false); // synchronous

    //         // Set the Authorization header if token exists
    //         if (token) {
    //             xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    //         }

    //         xhr.send(null);
    //         if (xhr.status === 200) {
    //             try {
    //                 const response = JSON.parse(xhr.responseText);

    //                 if (typeof response === 'number') {
    //                     return response;
    //                 }
    //             } catch (e) {
    //                 const num = parseInt(xhr.responseText, 10);
    //                 if (!isNaN(num)) {
    //                     return num;
    //                 }
    //             }
    //         }
    //     } catch (e) {
    //         console.error('Error verifying user status:', e);
    //     }
    //     return null;
    // }

    // async canActivate(): Promise<boolean> {
    //     const LAST_ROUTE_KEY = 'lastRouteTime';
    //     // Store last route time every time canActivate runs
    //     localStorage.setItem(LAST_ROUTE_KEY, Date.now().toString());
    //     const token = localStorage.getItem('accessToken');
    //     console.log(token, 'token from localStorage');
    //     let username = localStorage.getItem('userName');
    //     // --- TESTING: Expire every 60 seconds regardless of token ---
    //     const TEST_EXPIRY_KEY = 'testExpiryTime';
    //     let testExpiryTime = localStorage.getItem(TEST_EXPIRY_KEY);
    //     const now1 = Date.now();

    //     if (!testExpiryTime) {
    //         // Set expiry time for the first time
    //         testExpiryTime = (now1 + 60000).toString(); // 60 seconds from now
    //         localStorage.setItem(TEST_EXPIRY_KEY, testExpiryTime);
    //     }

    //     // if (token && !this.isTokenExpired(token) && now1 > parseInt(testExpiryTime, 10)) {
    //     if (token && !this.isTokenExpired(token)) {
    //         console.log('🕒 Simulated token expiry for testing (every 60 seconds)');
    //         localStorage.removeItem(TEST_EXPIRY_KEY); // Reset for next test
    //         if (username) {
    //             username = username.replace(/^"(.*)"$/, '$1');
    //             console.log('Username from localStorage:', username);

    //             const status = this.getUserStatus(username);
    //             if (status === 20) {
    //                 this.logout();
    //                 console.log('User status is 20, logging out');
    //                 return false;
    //             }
    //             if (status === 30) {
    //                 console.log('User status is 30, allowing access');
    //                 return true;
    //             }
    //             // If status is neither 20 nor 30, treat as not authenticated
    //             console.log('User status is neither 20 nor 30, logging out');
    //             this.logout();
    //             return false;
    //         }
    //         // If username is missing, treat as not authenticated
    //         this.logout();
    //         return false;
    //     }

    //     // Token is expired or not present
    //     const lastRouteTimeStr = localStorage.getItem(LAST_ROUTE_KEY);
    //     const lastRouteTime = lastRouteTimeStr ? parseInt(lastRouteTimeStr, 10) : 0;
    //     const now = Date.now();
    //     const diffMs = now - lastRouteTime;
    //     console.log(lastRouteTime, 'lastRouteTime');

    //     console.log(`🕒 Time since last route: ${diffMs} ms`);

    //     const diffHours = diffMs / (1000 * 60);
    //     console.log(diffHours);

    //     if (diffHours > 0.5 && this.isLoggedIn()) {
    //         console.log(`🕒 Time since last route: ${diffHours} hours`);

    //         // Call refresh token API (replace with your actual API call)
    //         const success = await this.refreshTokenService.refreshToken();
    //         if (success) {
    //             console.log('🔄 Token refreshed successfully');
    //             return true;
    //         } else {
    //             console.log('No valid token found, logging out');
    //             this.sessionService.stopHeartbeat?.();
    //             setTimeout(() => {
    //                 this.logout();
    //             }, 200);

    //             // Clean up local session info even before logout happens
    //             this.inMemoryStorageService.delete('userProfile');
    //             this.inMemoryStorageService.delete('accessToken');

    //             setTimeout(() => {
    //                 this.router.navigate(['/login']);
    //             }, 400);
    //             return false;
    //         }
    //         // Prevent navigation until refresh completes
    //         return false;
    //     }

    //     // Fallback: logout
    //     console.log('No valid token found, logging out');
    //     this.sessionService.stopHeartbeat?.();
    //     setTimeout(() => {
    //         this.logout();
    //     }, 200);

    //     // Clean up local session info even before logout happens
    //     this.inMemoryStorageService.delete('userProfile');
    //     this.inMemoryStorageService.delete('accessToken');

    //     setTimeout(() => {
    //         this.router.navigate(['/login']);
    //     }, 400);
    //     return false;
    // }

    async canActivate(): Promise<boolean> {
        const token = localStorage.getItem('accessToken');
        let username = localStorage.getItem('userName');

        // If token is valid
        if (token && !this.isTokenExpired(token)) {
            if (username) {
                username = username.replace(/^"(.*)"$/, '$1');
                const status = this.getUserStatus(username);
                if (status === 20) {
                    this.logout();
                    return false;
                }
                if (status === 30) {
                    return true;
                }
                this.logout();
                return false;
            }
            this.logout();
            return false;
        }

        // If token is invalid but user is still considered logged in: try refresh
        if (this.isLoggedIn()) {
            const success = await this.refreshTokenService.refreshToken();
            if (success) {
                return true;
            } else {
                this.logout();
                return false;
            }
        }

        // Fallback: logout
        this.logout();
        return false;
    }
    private isTokenExpired(token: string): boolean {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const expiry = payload.exp;

            const now = Math.floor(Date.now() / 1000);

            const remainingSeconds = expiry - now - 45;
            const remainingMinutes = (remainingSeconds / 60).toFixed(2);

            return remainingSeconds <= 0;
            // --- END TESTING ---

            // For production, use:
            // return expiry <= now;
        } catch (e) {
            return true;
        }
    }

    logout() {
        if (this.isLoggingOut) return;
        this.isLoggingOut = true;
        this.orderDraftService.clearDraft();
        // Clear password-expiry warning flag so it can show again on next login
        const user = localStorage.getItem('userName');
        if (user) {
            const normalizedUser = user.replace(/^"(.*)"$/, '$1');
            Object.keys(sessionStorage)
                .filter(k => k.startsWith(`pwdWarned_${normalizedUser}`))
                .forEach(k => sessionStorage.removeItem(k));
        }
        // Save values to keep
        const orders = localStorage.getItem('orders');
        const orderLines = localStorage.getItem('orderLines');
        const routeParams = localStorage.getItem('routeParams');
        const appVersion = localStorage.getItem('appVersion');
        const themePreference = localStorage.getItem('app-theme-preference'); // Preserve theme
        console.log('Logging out user...', orders, orderLines, routeParams, appVersion);
        console.log(appVersion, 'appVersion');

        const userProfile = JSON.parse(localStorage.getItem('userProfile') || '{}');

        let username = localStorage.getItem('userName');
        // this.sessionService.stopHeartbeat?.();

        const restoreLocalStorage = () => {
            if (orders !== null) localStorage.setItem('orders', orders);
            if (orderLines !== null) localStorage.setItem('orderLines', orderLines);
            if (routeParams !== null) localStorage.setItem('routeParams', routeParams);
            if (appVersion !== null) localStorage.setItem('appVersion', appVersion);
            if (themePreference !== null) localStorage.setItem('app-theme-preference', themePreference); // Restore theme
        };

        if (username) {
            username = username.replace(/^"(.*)"$/, '$1');
            this.http.post(`${environment.authApiUrl}logout?username=${encodeURIComponent(username)}`, {}, { responseType: 'text' }).subscribe(
                () => {
                    localStorage.clear();
                    restoreLocalStorage();
                    localStorage.removeItem('userProfile');
                    localStorage.removeItem('accessToken');
                    this.sessionService.stopHeartbeat?.();
                    this.isLoggingOut = false;
                    this.router.navigate(['/login']);
                },
                (error) => {
                    this.sessionService.stopHeartbeat?.();
                    localStorage.clear();
                    restoreLocalStorage();
                    this.isLoggingOut = false;
                    this.router.navigate(['/login']);
                }
            );
        } else {
            this.sessionService.stopHeartbeat?.();
            localStorage.clear();
            restoreLocalStorage();
            this.isLoggingOut = false;
            this.router.navigate(['/login']);
        }
    }

    isLoggedIn(): boolean {
        const token = localStorage.getItem('accessToken');
        if (!token) return false;

        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const expiry = payload.exp;
            const now = Math.floor(Date.now() / 1000);
            return expiry > now;
        } catch {
            return false;
        }
    }
}
// canActivate(): boolean {
//     const LAST_ROUTE_KEY = 'lastRouteTime';
//     // Store last route time every time canActivate runs
//     localStorage.setItem(LAST_ROUTE_KEY, Date.now().toString());
//     const token = localStorage.getItem('accessToken');
//     console.log(token, 'token from localStorage');
//     let username = localStorage.getItem('userName');

//     if (token && !this.isTokenExpired(token)) {
//         if (username) {
//             username = username.replace(/^"(.*)"$/, '$1');
//             console.log('Username from localStorage:', username);

//             const status = this.getUserStatus(username);
//             if (status === 20) {
//                 this.logout();
//                 console.log('User status is 20, logging out');

//                 return false;
//             }
//             if (status === 30) {
//                 console.log('User status is 30, allowing access');

//                 return true;
//             }
//             // If status is neither 20 nor 30, treat as not authenticated
//             console.log('User status is neither 20 nor 30, logging out');

//             this.logout();
//             return false;
//         }

//         return true;
//     }
//     console.log('No valid token found, logging out');

//     // If token is expired, stop heartbeat
//     this.sessionService.stopHeartbeat?.();
//     // Delay logout slightly to ensure router stack is stable
//     setTimeout(() => {
//         this.logout();
//     }, 200);

//     // Clean up local session info even before logout happens
//     this.inMemoryStorageService.delete('userProfile');
//     this.inMemoryStorageService.delete('accessToken');

//     // this.router.navigate(['/login']);
//     setTimeout(() => {
//         this.router.navigate(['/login']);
//     }, 400);
//     return false;
// }
// refreshToken() {
//     const accessToken = localStorage.getItem('accessToken');
//     if (!accessToken) return Promise.resolve(false);

//     // Call your API to refresh the token
//     return this.http
//         .post(`${environment.authApiUrl}refresh-token`, { accessToken })
//         .toPromise()
//         .then((response: any) => {
//             console.log('🔄 Refresh token response:', response);

//             const newToken = response?.accessToken;
//             if (newToken) {
//                 console.log('🔄 New access token received:', newToken);
//                 localStorage.setItem('accessToken', newToken);
//                 return true;
//             }
//             return false;
//         })
//         .catch((error) => {
//             console.error('❌ Refresh token API failed:', error);
//             return false;
//         });
// }

// private isTokenExpired(token: string): boolean {
//     try {
//         const payload = JSON.parse(atob(token.split('.')[1]));
//         const expiry = payload.exp;
//         const now = Math.floor(Date.now() / 1000);

//         const remainingSeconds = expiry - now;
//         const remainingMinutes = (remainingSeconds / 60).toFixed(2);

//         console.log('🔐 JWT Payload:', payload);
//         console.log(`🕒 Token will expire in: ${remainingSeconds}s (${remainingMinutes} mins)`);

//         return remainingSeconds <= 0;
//     } catch (e) {
//         console.error('⚠️ Invalid token format:', e);
//         return true;
//     }
// }
